// A.5.4H.4C.2 — libellé de source d'un événement PX4 canonique.
// Distingue une OBSERVATION construite par SkyCore depuis la télémétrie (armed/mode/failsafe)
// d'un événement réellement émis par PX4. On n'invente JAMAIS de causalité.
//   px4_statustext      -> "PX4"
//   px4_event           -> "PX4"
//   px4_event_sequence  -> "PX4"
//   skycore_observation -> "SkyCore observation"
export function px4SourceLabel(source) {
  return source === "skycore_observation" ? "SkyCore observation" : "PX4";
}
